import React from 'react';
import { useFormikContext } from 'formik';

import NavigationPrompt from 'shared/components/molecules/NavigationPrompt';

import { SUBMISSION_COPY } from 'shared/config/copy';

interface Props {
  active?: boolean;
}

const SubmissionFormNavigationPrompt = <Values extends {}>({ active = false }: Props) => {
  const { dirty } = useFormikContext<Values>();

  return (
    <NavigationPrompt
      when={({ currentLocation, nextLocation }) => {
        return active && dirty && currentLocation.pathname !== nextLocation.pathname;
      }}
      confirmButtonText={'Exit'}
      cancelButtonText={'Cancel'}
      title={SUBMISSION_COPY.MODAL_TITLE_EXIT}
      promptText={SUBMISSION_COPY.PROMPT_EXIT_SUBMISSION_FORM}
    />
  );
};

export default SubmissionFormNavigationPrompt;
